export const MEMBERS_DATA = {
    total: 40,
    data: [
        { id: 1, memberName: "James Saunders", role: "Reviewer" },
        { id: 2, memberName: "Erwin D. Polizzi ", role: "Reviewer" },
        { id: 3, memberName: "James A. Lancaster ", role: "Reviewer" },
        { id: 4, memberName: "Erwin D. Polizzi", role: "Reviewer" },
        { id: 5, memberName: "Kimberly C. Brown", role: "Data entry user" },
        { id: 6, memberName: "Randolph B. Knight ", role: "Data entry user" },
        { id: 7, memberName: "James Saunders", role: "Reviewer" },
        { id: 8, memberName: "Erwin D. Polizzi ", role: "Reviewer" },
        { id: 9, memberName: "James A. Lancaster ", role: "Reviewer" },
        { id: 10, memberName: "Erwin D. Polizzi", role: "Reviewer" },
        { id: 11, memberName: "Kimberly C. Brown", role: "Data entry user" },
        { id: 12, memberName: "Randolph B. Knight ", role: "Data entry user" },
        { id: 13, memberName: "James Saunders", role: "Reviewer" },
        { id: 14, memberName: "Erwin D. Polizzi ", role: "Reviewer" },
        { id: 15, memberName: "James A. Lancaster ", role: "Reviewer" },
        { id: 16, memberName: "Erwin D. Polizzi", role: "Reviewer" },
        { id: 17, memberName: "Kimberly C. Brown", role: "Data entry user" },
        { id: 18, memberName: "Randolph B. Knight ", role: "Data entry user" },
        { id: 19, memberName: "James Saunders", role: "Reviewer" },
        { id: 20, memberName: "Erwin D. Polizzi ", role: "Reviewer" },
        { id: 21, memberName: "James A. Lancaster ", role: "Reviewer" },
        { id: 22, memberName: "Erwin D. Polizzi", role: "Reviewer" },
        { id: 23, memberName: "Kimberly C. Brown", role: "Data entry user" },
        { id: 24, memberName: "Randolph B. Knight ", role: "Data entry user" },
        { id: 25, memberName: "James Saunders", role: "Reviewer" },
        { id: 26, memberName: "Erwin D. Polizzi ", role: "Reviewer" },
        { id: 27, memberName: "James A. Lancaster ", role: "Reviewer" },
        { id: 28, memberName: "Erwin D. Polizzi", role: "Reviewer" },
        { id: 29, memberName: "Kimberly C. Brown", role: "Data entry user" },
        { id: 30, memberName: "Randolph B. Knight ", role: "Data entry user" },
        { id: 31, memberName: "James Saunders", role: "Reviewer" },
        { id: 32, memberName: "Erwin D. Polizzi ", role: "Reviewer" },
        { id: 33, memberName: "James A. Lancaster ", role: "Reviewer" },
        { id: 34, memberName: "Erwin D. Polizzi", role: "Reviewer" },
        { id: 35, memberName: "Kimberly C. Brown", role: "Data entry user" },
        { id: 36, memberName: "Randolph B. Knight ", role: "Data entry user" },
        { id: 37, memberName: "James Saunders", role: "Reviewer" },
        { id: 38, memberName: "Erwin D. Polizzi ", role: "Reviewer" },
        { id: 39, memberName: "James A. Lancaster ", role: "Reviewer" },
        { id: 40, memberName: "Erwin D. Polizzi", role: "Reviewer" },
    ]
}


export const ASSIGN_MEMBER_LOADING_STATES = {
    GET_MEMBER_USERS_LIST_LOADING : "GET_MEMBER_USERS_LIST_LOADING",
    GET_MEMBER_USERS_LIST_READY : "GET_MEMBER_USERS_LIST_READY",
    ASSIGN_TO_USER_LOADING:"ASSIGN_TO_USER_LOADING",
    ASSIGN_TO_USER_READY: "ASSIGN_TO_USER_READY",
    GET_MEMBER_ROLES_LOADING:"GET_MEMBER_ROLES_LOADING",
    GET_MEMBER_ROLES_READY:"GET_MEMBER_ROLES_READY",
}

export const ASSIGN_MEMBER_MESSAGE_MAP = {
    [ASSIGN_MEMBER_LOADING_STATES.GET_MEMBER_USERS_LIST_LOADING]:"",
    [ASSIGN_MEMBER_LOADING_STATES.ASSIGN_TO_USER_LOADING]:"Assigning to user"
}